module.exports = __webpack_public_path__ + "img/special_moisturegel_202309.ce917cfe.jpg";